// @ts-nocheck
import {
    CheckboxFieldDefinition,
    ImagePickerFieldDefinition,
    RichTextFieldDefinition,
} from "@insite/client-framework/Types/FieldDefinition";

export const blogIsFeaturedField = {
    defaultValue: false,
    editorTemplate: "CheckboxField",
    fieldType: "General",
} as CheckboxFieldDefinition;

export const blogFeaturedImageField = {
    defaultValue: "",
    editorTemplate: "ImagePickerField",
    fieldType: "Contextual",
} as ImagePickerFieldDefinition;

export const blogFeaturedTextField = {
    defaultValue: "",
    editorTemplate: "RichTextField",
    fieldType: "Translatable",
} as RichTextFieldDefinition;
